import {createSelector} from "reselect";
import {AppStateType} from "./rootReducer";

const getMixCompilations = (state: AppStateType) => {
    return state.main.mixCompilations;
};

export const getOurCompilations = createSelector(getMixCompilations,
    (mix) => {
        return mix.filter((item: any) => item.type === 0);
    });

export const getHookahCompilations = createSelector(getMixCompilations,
    (mix) => {
        return mix.filter((item: any) => item.type === 1);
    });

export const getAuthorCompilations = createSelector(getMixCompilations,
    (mix) => {
        return mix.filter((item: any) => item.type === 2);
    });

